<script setup lang="ts">
import { ref } from 'vue'
import { T } from '@tolgee/vue'
import TabButton from '@/components/TabButton.vue'
import LeaderboardGeneralTab from '@/components/LeaderboardGeneralTab.vue'
import LeaderboardLoyaltyTab from '@/components/LeaderboardLoyaltyTab.vue'

enum LeaderboardTab {
  GENERAL = 'general',
  LOYALTY = 'loyalty'
}

const activeTab = ref<LeaderboardTab>(LeaderboardTab.GENERAL)

</script>

<template>
  <div class="flex-1 w-full h-screen flex flex-col items-center">
    <div
      class="px-4 flex w-full pt-6"
    >
      <div
        class="flex w-full rounded-xl p-0.5 bg-dark-bottom-layer"
      >
        <TabButton
          :is-active="activeTab === LeaderboardTab.GENERAL"
          @click="activeTab = LeaderboardTab.GENERAL"
        >
          <T
            key-name="leaderboard.general"
            default-value="General"
          />
        </TabButton>
        <TabButton
          :is-active="activeTab === LeaderboardTab.LOYALTY"
          @click="activeTab = LeaderboardTab.LOYALTY"
        >
          <T
            key-name="leaderboard.loyalty"
            default-value="Loyalty"
          />
        </TabButton>
      </div>
    </div>
    <LeaderboardGeneralTab
      v-if="activeTab === LeaderboardTab.GENERAL"
    />
    <LeaderboardLoyaltyTab v-else-if="activeTab === LeaderboardTab.LOYALTY" />
  </div>
</template>
<style lang="scss">
</style>
